import { createStyles, Paper, Slide, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import backgroundImage from '../../../../../assets/background.jpg';

const modalElevation = 16;
const dockedElevation = 4;

const styles = createStyles(theme => ({
  root: {
    height: '100%',
    maxHeight: '100%',
    display: 'flex',
    position: 'fixed',
    top: 0,
    left: 0,
    outline: 0,
    colorScheme: 'dark',
    backgroundImage:
      theme.palette.type === 'light'
        ? `linear-gradient(to right,
     rgba(20, 30, 48, 0.94),
     rgba(37, 43, 59, 0.94)), url(${backgroundImage})`
        : `linear-gradient(to right,
     rgba(20, 30, 48, 0.94),
     rgba(14, 21, 38, 0.94)), url(${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  docked: {
    zIndex: theme.zIndex.appBar - 1,
  },
  modal: {
    zIndex: theme.zIndex.drawer,
  },
}));

const AppDrawerComplexColumnGroup = React.forwardRef(
  (props, ref) => {
    const { classes, open, modal, children } = props;
    return (
      <Slide
        in={open || !modal}
        direction="right"
      >
        <Paper
          square
          ref={ref}
          className={classNames(
            classes.root,
            modal ? classes.modal : classes.docked,
          )}
          elevation={modal
            ? modalElevation
            : dockedElevation}
        >
          {children}
        </Paper>
      </Slide>
    );
  },
);

export default withStyles(styles, { name: 'AppDrawerComplexColumnGroup' })(AppDrawerComplexColumnGroup);
